module.exports = __webpack_public_path__ + "static/img/Insgram.c70d19c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/Insgram.png
// module id = 67lx
// module chunks = 1